interface ViewportEventConfig {
    once?: boolean
    uniqueKey?: string | null
}

type IntersectionObserverInit = {
    root?: Element | null
    rootMargin?: string
    threshold?: number | number[]
}

const triggeredEvents: Set<string> = new Set()

export function viewportEvent(
    element: Element | null,
    callback: () => void,
    { once = false, uniqueKey = null }: ViewportEventConfig = {},
    options: IntersectionObserverInit = { threshold: 0.5 }
): IntersectionObserver | null {
    if (!element) {
        console.error('viewportEvent: Valid DOM element required.')
        return null
    }

    if (once && uniqueKey && triggeredEvents.has(uniqueKey)) {
        return null
    }

    const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (once && uniqueKey) {
                    triggeredEvents.add(uniqueKey)
                }
                callback()
                observerInstance.disconnect()
            }
        })
    }, options)

    observer.observe(element)
    return observer
}
